import { Link, NavItem } from "@menu/core/types";
import MenuContext from "@menu/core/menu.context";
import { removeSpaces } from "@menu/core/lib";

enum PathMatch {
    None = 0,
    SubNav = 10,
    LinkMatch = 5,
    KeyMatch = 1
}

class NavItemState {
    isOnPath = false;
    isActive = false;
    pathState = PathMatch.None;
}

export class NavItemAndState {
    item: NavItem;
    state = new NavItemState();

    constructor(item: NavItem) {
        this.item = item;
    }
}

const compareNavItemState = (a: NavItemAndState, b: NavItemAndState) => {
    const stateA = a.state.pathState as number;
    const stateB = b.state.pathState as number;

    if (stateA > stateB) {
        return -1;
    }

    if (stateA < stateB) {
        return 1;
    }

    return 0;
}

const areEqual = (a?: NavItem, b?: NavItem) => {
    if (!a || !b) {
        return false;
    }

    if (a === b) {
        return true;
    }

    const getComparisonKey = (item: NavItem) => {
        return `${item.link}|${item.title}|${item.subnavItems.length}`;
    }

    return getComparisonKey(a) === getComparisonKey(b);
}

const getPathState = (path: string, navItem: NavItem) => {
    if (!path || navItem.link == null) {
        return PathMatch.None;
    }

    const key = removeSpaces(path);

    const href = window.location.href;

    const isKeyMatch = (value: string) => removeSpaces(value) === key;

    const isLinkMatch = (item: Link) => {
        return item.link !== "#" && (href.includes(item.link) || isKeyMatch(item.title));
    }

    if (isLinkMatch(navItem)) {
        return PathMatch.LinkMatch;
    }

    if (navItem.subnavItems) {
        const subNavMatch = navItem.subnavItems.find(x => isLinkMatch(x));

        if (subNavMatch) {
            return PathMatch.SubNav;
        }
    }

    const altSearchables = navItem.link.toLowerCase().substring(1).split("|");

    if (!altSearchables || !key) {
        return PathMatch.None;
    }

    const match = altSearchables.find(x => isKeyMatch(x));

    return !!match ? PathMatch.KeyMatch : PathMatch.None;
}

const getNavItemsWithState = (context: MenuContext) => {
    const isBusiness = context.isBusinessSite;

    let path = context.location?.pathname;

    const items: NavItemAndState[] = [];

    if (!path) {
        const index = isBusiness ? 3 : 2;

        path = window.location.pathname.split("/")[index];
    }

    const links = context.site.navItems;

    if (!links) {
        return items;
    }

    links.forEach(x => items.push(new NavItemAndState(x)));

    for (let item of items) {
        item.state.pathState = getPathState(path, item.item);
        item.state.isActive = areEqual(item.item, context.selectedArea);
    }

    var onPathItems = items.filter(x => x.state.pathState !== PathMatch.None);

    switch (onPathItems.length) {
        case 0:
            break;

        case 1:
            onPathItems[0].state.isOnPath = true;
            break;

        default:
            const sorted = onPathItems.sort(compareNavItemState);
            sorted[0].state.isOnPath = true;
            break;
    }

    return items;
}

export default getNavItemsWithState;